module.exports = __webpack_public_path__ + "static/icone-tef-19a6b915daca3e0aa7a1f7327a3bc993.svg";